import { useState, useEffect, use } from "react";
import post from "../assets/images/write.png";
import user from "../assets/images/user.png";
import Calendar from "./calendar";
import { FiSearch } from "react-icons/fi";
import "../assets/styles/post.css";
import dogImage from "../assets/images/advertisement/dog-circle.gif";
import Logo from "../assets/images/logo/321VETS_LOGO.png";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
function Post() {
  const [show, setShow] = useState("none");
  const [mobile, setMobile] = useState("none");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const navigator = useNavigate();
  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
  }, []);

  function handleSearch() {
    navigator(`/search?query=${searchValue}`);
  }
  function hide() {
    show === "none" ? setShow("flex") : setShow("none");
  }

  function menu() {
    mobile === "none" ? setMobile("flex") : setMobile("none");
  }

  return (
    <div className="post">
      {/* Menu shown on desktop and ipads */}
      <div className="desktop-menu">
        <img src={Logo} alt="321 vets" width={100} />
        <a
          href="/post"
          className="inline-flex items-center px-2 py-1 border border-gray-300 rounded hover:bg-gray-100"
        >
          <img className="post_icon" src={post} alt="post-icon" />
          <span className="ml-1">Create a posting</span>
        </a>
        <a
          href={isLoggedIn ? "/account" : "/login"}
          className="inline-flex items-center px-2 py-1 border border-gray-300 rounded hover:bg-gray-100"
        >
          <img className="post_icon" src={user} alt="user-icon" />
          <span className="ml-1">
            {isLoggedIn ? "my account" : "login / sign up"}
          </span>
        </a>
        <div className="flex gap-2 items-center border border-gray-300 rounded px-2 py-1">
          <input
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearch();
            }}
            type="text"
            placeholder="search 321 Vets"
            className="px-2 py-1 border border-gray-300 rounded"
          />
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={handleSearch}
          >
            <Search />
          </button>
        </div>

        {/* display list of nearby cities when user clicks "Nearby cities" */}
        <div className="cities-display">
          <span
            onClick={hide}
            className="cursor-pointer text-blue-700 underline"
          >
            Nearby Cities
          </span>
          <div className="cities-list" style={{ display: show }}>
            <a href="/city">West Melbourne</a>
            <a href="/city">Palm Bay</a>
            <a href="/city">Indian harbor beach</a>
            <a href="/city">Satellite beach</a>
            <a href="/city">South Patrick shores</a>
            <a href="/city">Micco</a>
            <a href="/city">Cocoa Beach</a>
            <a href="/city">Merritt Island</a>
            <a href="/city">Rockledge</a>
            <a href="/city">Sebastian</a>
          </div>
        </div>
        <div className="tablet-ads">
          <p id="probiotic-para">Advertisement</p>
          <a
            href="https://www.vetrelief.pet/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="first-ad">
              <h4>
                On-demand <br />
                Online Vet Appointments
              </h4>
              <img src={dogImage} width={90} />
              <h4>Book Now</h4>
            </div>
          </a>
        </div>
      </div>
      {/* Menu shown on mobile and small devices */}
      <div className="mobile-menu">
        <a
          href={isLoggedIn ? "/account" : "/login"}
          className="block px-2 py-1 border border-gray-300 rounded hover:bg-gray-100 mb-2"
        >
          {isLoggedIn ? "Account" : "Login / Sign up"}
        </a>
        <a
          href="/post"
          className="block px-2 py-1 border border-gray-300 rounded hover:bg-gray-100 mb-2"
        >
          Create post
        </a>
        {/* Display list of cities when user clicks on nearby cities */}
        <a
          onClick={menu}
          style={{ color: "#551A8B" }}
          className="cursor-pointer underline"
        >
          Nearby cities
        </a>
        <div
          className="cities-list"
          style={{ display: mobile, textAlign: "center" }}
        >
          <a href="/city">West Melbourne</a>
          <a href="/city">Palm Bay</a>
          <a href="/city">Indian harbor beach</a>
          <a href="/city">Satellite beach</a>
          <a href="/city">South Patrick shores</a>
          <a href="/city">Micco</a>
          <a href="/city">Cocoa Beach</a>
          <a href="/city">Merritt Island</a>
          <a href="/city">Rockledge</a>
          <a href="/city">Sebastian</a>
        </div>
      </div>
    </div>
  );
}

export default Post;
